import React, { Component } from "react";
export default class ContactUs extends Component {
  render() {
    return (
      <section id="contact">
        <div className="row section-head">
          <div className="two columns header-col">
            <h1>
              <span>Get In Touch.</span>
            </h1>
          </div>
          <div className="ten columns">
            <p className="lead">
              I will be so glad if you get in touch with me at
              @bilalsarimeseli@gmail.com
            </p>
          </div>
        </div>
      </section>
    );
  }
}
